import { type ReactNode } from 'react';

import { Paper, type SxProps, type Theme } from '@mui/material';

// A fixed-width navigation rail: a square Paper surface (gardenia, 248px, right
// border) that takes its nav content as children. A reusable layout shell —
// the look lives here; the call site passes in the menu. Pass `sx` to layer on
// responsive behaviour (e.g. hide the rail at narrow container widths).
const Sidebar = ({
  children,
  sx,
}: {
  children: ReactNode;
  sx?: SxProps<Theme>;
}) => (
  <Paper
    square
    sx={[
      {
        width: 248,
        flexShrink: 0,
        display: 'flex',
        flexDirection: 'column',
        bgcolor: 'background.default',
        borderRight: 1,
        borderColor: 'custom.neutral.200',
        overflow: 'auto',
      },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  >
    {children}
  </Paper>
);

export default Sidebar;
